"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_BREADCRUMB_REACTION_EMOJI_LENGTH = void 0;
exports.MAX_BREADCRUMB_REACTION_EMOJI_LENGTH = 32;
//# sourceMappingURL=breadcrumb-reaction.constants.js.map